import { FC } from 'react'

import useDefineOnboardingComponent from '../useDefineOnboardingComponent'

import { SessionStorageKeys } from 'constants/storage'
import { scenarioName, stepName } from 'constants/onboarding'

interface IScenario {
  configName: scenarioName
  status: stepName[]
  setStatus: React.Dispatch<React.SetStateAction<stepName[] | null>>
}

const Scenario: FC<IScenario> = ({ configName, status, setStatus }) => {
  const finishStep = () => {
    const newStatus = [...status].slice(1)
    setStatus(newStatus)
    const onboardingStatus = JSON.parse(
      sessionStorage.getItem(SessionStorageKeys.ONBOARDING_STATUS) || '{}'
    )
    sessionStorage.setItem(
      SessionStorageKeys.ONBOARDING_STATUS,
      JSON.stringify({ ...onboardingStatus, [configName]: newStatus })
    )
  }

  const currComponent = useDefineOnboardingComponent(status[0], finishStep)

  return <>{currComponent}</>
}

export default Scenario
